import { getSiblings } from "../../helpers";

export default class Tabs {
	constructor(el) {
		if (!el) return;
		this.el = el;
		this.debounce_timer = null;
		this.navbar = document.getElementById("filter-nav");
		this.shouldStickPosition = 0;

		if (this.navbar === null) {
			this.shouldStickPosition = window.scrollY;
		} else {
			this.shouldStickPosition =
				window.scrollY + this.navbar.getBoundingClientRect().top;
		}
		this.tabs = this.el.querySelectorAll(".item");
		this.tabsContent = this.el.nextElementSibling.classList.contains(
			"tabs-content"
		)
			? this.el.nextElementSibling
			: null;

		this.events();
	}

	onTabClick(ev) {
		ev.preventDefault();

		Array.from(this.el.querySelectorAll("a")).map((el) =>
			el.classList.remove("active")
		);
		ev.currentTarget.classList.add("active");

		const selectedTabId = ev.currentTarget.getAttribute("href");
		const selectedTabContent = document.querySelector(selectedTabId);
		const siblingsTabsContent = getSiblings(selectedTabContent);

		selectedTabContent && selectedTabContent.classList.add("active");
		siblingsTabsContent &&
			Array.from(siblingsTabsContent).map((content) =>
				content.classList.remove("active")
			);

		Array.from(this.tabsContent.querySelectorAll(".tab-content")).map(
			(tabContent) => {
				if (
					Array.from(
						tabContent.querySelectorAll(".section-main-slider .swiper")
					).length > 0
				) {
					Array.from(
						tabContent.querySelectorAll(".section-main-slider .swiper")
					).map((slider) => window.dispatchEvent(new Event("slider.reset")));
				}
			}
		);

		if (ev.currentTarget?.dataset?.premium === "true") {
			ev.currentTarget
				.closest("section.flexible-section")
				.classList.add("is-premium");
		} else {
			ev.currentTarget
				.closest("section.flexible-section")
				.classList.remove("is-premium");
		}

		if (this.navbar === null) {
			window.dispatchEvent(new Event("resize"));
		}
	}

	onScroll() {
		if (this.debounce_timer) {
			window.clearTimeout(this.debounce_timer);
		}

		this.debounce_timer = window.setTimeout(() => {
			if (window.scrollY >= this.shouldStickPosition - 50) {
				this.navbar.classList.add("sticky-filters");
			} else {
				this.navbar.classList.remove("sticky-filters");
			}
		}, 50);
	}

	events() {
		if (!this.navbar) {
			Array.from(this.tabs).map((tab) => {
				tab
					.querySelector("a")
					.addEventListener("click", this.onTabClick.bind(this));
			});
		} else {
			window.addEventListener("scroll", this.onScroll.bind(this), false);
		}
	}
}
